<script>
  import { slide } from 'svelte/transition';
  import Wysiwyg from '$lib/default/Wysiwyg.svelte';

  let seo = {
    content1: 'test 1',
    content2: 'test 2',
    btnText: 'text',
  };

  let active = false;
</script>

<section class="seo">
  <div class="container">
    <div class="seo__content-1 entry-content">
      <Wysiwyg content={seo.content1} />
    </div>
    {#if seo.content2}
      {#if active}
        <div class="seo__content-2 entry-content" transition:slide>
          <Wysiwyg content={seo.content2} />
        </div>
      {/if}
      {#if seo.btnText}
        <div class="seo__more-wrap">
          <button
            class="seo__more-btn btn btn-icon"
            class:active
            on:click={() => {
              active = !active;
            }}
          >
            <i class="isax isax-arrow-down-1 seo__more-btn-icon" />
            {#if active}
              {seo.btnText.less}
            {:else}
              {seo.btnText.more}
            {/if}
          </button>
        </div>
      {/if}
    {/if}
  </div>
</section>

<style lang="scss">
  .seo {
    &__content-2 {
      // max-height: 22rem;
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.2s ease-out;

      &.open {
        // max-height: ;
      }
    }

    &__more-wrap {
      display: flex;
      justify-content: center;
    }

    &__more-btn {
      font-size: 1.3rem;
      text-transform: uppercase;
      letter-spacing: 0.06em;
      padding: 1rem 2rem;
      border: 1px solid $light-border;
      border-radius: 30px;
      gap: 0.8rem;
      margin-top: 6rem;

      &-icon {
        font-weight: 900;
        transition: transform 0.2s;
      }

      &.active {
        .seo__more-btn-icon {
          transform: rotateX(180deg);
        }
      }
    }
  }
</style>
